import makeApi from 'libs/core/configureAxios'

const api = makeApi(`${process.env.REACT_APP_API_BASE_URL}`)

const createDomain = payload =>
  api.post(`/platform/company?accountId=${payload.accountId}`, payload.data)

const getDNS = payload => api.get(`/platform/company/dns/record`, payload)

export default {
  createDomain,
  getDNS,
}
